import { useState, useEffect } from "react";
import axios from "axios";

const SideFilter = ({ selectedFilters, handleFilterChange }) => {
  // hold the four groups separately; start with empty arrays
  const [filters, setFilters] = useState({
    applicationUse: [],
    fiberType: [],
    industryServed: [],
    testProtocol: []
  });

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}get_product_filters`
        );
        // res.data.data should contain the four arrays we need
        setFilters(res?.data?.data ?? {});
      } catch (err) {
        console.error("Could not load filters", err);
      }
    };

    fetchFilters();
  }, []);

  /** Little helper so we don’t repeat markup */
  const renderFilterGroup = (title, list, category) =>
    list.length > 0 && (
        <div className="mb-4">
            <h6 className="fw-semibold mb-2">{title}</h6>
            {list.map((filter) => (
                <div key={filter.id} className="form-check mb-2">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id={`${title}-${filter.id}`}
                    checked={selectedFilters[category]?.includes(filter.id) || false}
                    onChange={handleFilterChange(category, filter.id)}
                />
                <label className="form-check-label" htmlFor={`${title}-${filter.id}`}>
                    {filter.name}
                </label>
                </div>
            ))}
        </div>
  );


  return (
    <>
        {renderFilterGroup("Application Use", filters.applicationUse, "applicationUse")}
        {renderFilterGroup("Fiber Type", filters.fiberType, "fiberType")}
        {renderFilterGroup("Industry Served", filters.industryServed, "industryServed")}
        {renderFilterGroup("Test Protocol", filters.testProtocol, "testProtocol")}
    </>
  );
};

export default SideFilter;
